module.exports = __webpack_public_path__ + "static/media/subway_tick.3d78f926.svg";